import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import {
    Dashboard as DashboardIcon,
    Event as EventIcon,
    People as PeopleIcon,
    CardGiftcard as SpreadIcon,
    Announcement as AnnouncementIcon,
    AdminPanelSettings as AdminIcon,
    Schedule as ScheduleIcon,
    Campaign as CampaignIcon,
    AccessTime as AccessTimeIcon,
    AutoStories as AutoStoriesIcon
} from '@mui/icons-material';

const AdminMenu: React.FC = () => {
    const menuItems = [
        { text: 'Dashboard', icon: <DashboardIcon />, path: '/admin' },
        { text: 'Kullanıcılar', icon: <PeopleIcon />, path: '/admin/users' },
        { text: 'Adminler', icon: <AdminIcon />, path: '/admin/admins' },
        { text: 'Duyurular', icon: <CampaignIcon />, path: '/admin/announcements' },
        { text: 'Randevular', icon: <EventIcon />, path: '/admin/appointment' },
        { text: 'Fallar', icon: <SpreadIcon />, path: '/admin/spreads' }
    ];

    return (
        <List>
            {menuItems.map((item) => (
                <ListItem
                    button
                    component={RouterLink}
                    to={item.path}
                    key={item.path}
                >
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} />
                </ListItem>
            ))}
        </List>
    );
};

export default AdminMenu; 